import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { createProductGroupValidation } from "../../validation/InventoryInfo";
import Button from "../Reusable/Button";
import TextField from "../Reusable/TextField";

const ProductGroupForm = (props: any) => {
  const { setOpenCategoryFormPopup, data = null } = props;
  const {
    control,
    formState: { errors },
    handleSubmit,
    setError,
  } = useForm<any>({
    resolver: yupResolver(createProductGroupValidation),
    ...(data
      ? {
          defaultValues: {
            ...data,
          },
        }
      : null),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["category"],
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.CATEGORY;
    const formData = {
      ...values,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setOpenCategoryFormPopup((prev) => !prev);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      onSubmit={handleSubmit((data) => handleCreate(data, setError))}
      autoComplete="off"
    >
      <div className={tw`grid gap-x-2`}>
        <TextField
          label="Name"
          name={"name"}
          control={control}
          placeholder="Enter name"
        />
      </div>
      <div className={tw`mt-4 w-full `}>
        <div className={tw`w-32 ml-auto`}>
          <Button label="Save" isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default ProductGroupForm;
